import { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import styled from '@emotion/styled';

import useQueryParams from '../../../hooks/useQueryParams';

import { useNavigate, useLocation } from 'react-router-dom';

import Items from './Tabs/Items';
import Values from './Tabs/Values';
import Colors from './Tabs/Colors';
import Pricing from './Tabs/Pricing';

const ActiveTab = ({ activeTab, children }) => {

  console.log(activeTab);

  let tabs = [
    {panel: "items", content: <Items />},
    {panel: "values", content: <Values />},
    {panel: "colors", content: <Colors />},
    {panel: "pricing", content: <Pricing />}
  ]

  return (
    <div>
      {tabs.map((tab, index) => (
        <div key={index}>
          {activeTab === tab.panel && tab.content}
        </div>
      ))}
    </div>
  );

}

const InventorySettings = () => {

  const navigate = useNavigate();

  const location = useLocation();
  const currentPath = location.pathname;
  const paths = currentPath.split('/');
  console.log(paths);
  let activeTab = paths?.[3] || 'items';

  const handleTabChange = (event, newValue) => {
    // Navigate to the absolute path
    navigate(`/settings/inventory/${newValue}`);
  };

  const tabs = [
    {
      label: 'Inventory Items',
      value: 'items'
    }, 
    {
      label: 'Colors',
      value: 'colors'
    },
    {
      label: 'Wig Values',
      value: 'values'
    },
    {
      label: 'Pricing',
      value: 'pricing'
    }
  ]

  return (
    <div>
      <Tabs value={activeTab} sx={{borderBottom: "1px solid #DEDEDF", minHeight: "auto"}}>
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} value={tab.value} sx={{gap: '.5rem', padding: "1rem 3rem", minHeight: "auto"}} onClick={(e) => handleTabChange(e, tab.value)} />
        ))}
      </Tabs>

      <ActiveTab activeTab={activeTab} />
    </div>
  );
};

export default InventorySettings;